webpackJsonp([280],{

/***/ 1098:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupBatchCustomerTable_vue__ = __webpack_require__(2693);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bf60cf8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupBatchCustomerTable_vue__ = __webpack_require__(4071);
function injectStyle (ssrContext) {
  __webpack_require__(4069)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bf60cf8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupBatchCustomerTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bf60cf8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupBatchCustomerTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * ElementUI 日期选择组件的参数
 * @Author: anker.wang
 * @Date: 2018-01-08 11:27:07
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-01-08 11:28:27
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dateTimePickerOptions: {
        shortcuts: [{
          text: '一周后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '明天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      dateTimePickerRangeOptions: {
        shortcuts: [{
          text: '最近1周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近6个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近2年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 730);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1095);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  }
});

/***/ }),

/***/ 2693:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_dateTimePicker__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_table__ = __webpack_require__(1346);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__core_mixins_table__["b" /* default */], __WEBPACK_IMPORTED_MODULE_1__core_mixins_dateTimePicker__["a" /* default */]],
  components: {},
  data: function data() {
    return {
      search: {
        show_filter: '',
        keyword: '',
        type: this.$route.params.type || null
      },
      optionModel: {
        customerType: []
      },
      uploadDialogVisible: false,
      projectDialog: {
        visible: false,
        customerId: null,
        customerName: '',
        projectid: null
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.customer.options;
    }
  })),

  created: function created() {},


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), request.map(['getBaiscProjectTable', 'getProjectDetail']), {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {
      params = filter.copyJson(params);
      return request.page('getCustomerTable', params);
    },
    formatDate: function formatDate(value) {
      return filter.formatUnix(value);
    },
    openProjectMarketDialog: function openProjectMarketDialog(row) {
      this.projectDialog = {
        visible: true,
        customerId: row.id,
        customerName: row.name,
        projectid: null
      };
    },
    resetProjectDialog: function resetProjectDialog() {
      this.projectDialog = {
        visible: false,
        customerId: null,
        customerName: '',
        projectid: null
      };
    },
    goProjectMarketTable: function goProjectMarketTable() {
      if (!this.projectDialog.projectid) {
        this.$message.error('请选择项目');
        return;
      }
      var customerId = this.projectDialog.customerId;
      var projectId = this.projectDialog.projectid;
      this.projectDialog.visible = false;
      this.$router.push('/group-batch/market-table/' + customerId + '/project/' + projectId);
    }
  })
});

/***/ }),

/***/ 4069:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4070);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("941553fe", content, true, {});

/***/ }),

/***/ 4070:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".link[data-v-1bf60cf8]{color:#409eff;padding:5px 10px;cursor:pointer}", "", {"version":3,"sources":["/workspace/src/views/group-batch/pages/GroupBatchCustomerTable.vue"],"names":[],"mappings":"AACA,uBAAuB,cAAc,iBAAiB,cAAc,CACnE","file":"GroupBatchCustomerTable.vue","sourcesContent":["\n.link[data-v-1bf60cf8]{color:#409EFF;padding:5px 10px;cursor:pointer\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4071:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("任务管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":true}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"客户名称","prop":"keyword"}},[_c('el-input',{attrs:{"placeholder":"请输入客户名称","clearable":""},model:{value:(_vm.search.keyword),callback:function ($$v) {_vm.$set(_vm.search, "keyword", $$v)},expression:"search.keyword"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit","size":"mini"}},[_vm._v("搜索\n        ")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID","min-width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"number","label":"客户编号","min-width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"客户名称","min-width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"440"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('button-gutter',[_c('router-link',{attrs:{"to":("/group-batch/table/" + (scope.row.id))}},[_c('el-button',{attrs:{"type":"primary","size":"mini"}},[_vm._v("群组批次")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":("/group-batch/market-table/" + (scope.row.id))}},[_c('el-button',{attrs:{"type":"primary","size":"mini"}},[_vm._v("客户群组门店关系")])],1),_vm._v(" "),_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.openProjectMarketDialog(scope.row)}}},[_vm._v("项目群组门店关系")])],1)]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2),_vm._v(" "),_c('el-dialog',{attrs:{"title":"选择项目","visible":_vm.projectDialog.visible,"width":"480px"},on:{"update:visible":function($event){return _vm.$set(_vm.projectDialog, "visible", $event)},"closed":_vm.resetProjectDialog}},[_c('el-form',{attrs:{"label-width":"96px","size":"medium"}},[_c('el-form-item',{attrs:{"label":"客户"}},[_c('span',[_vm._v(_vm._s(_vm.projectDialog.customerName))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目","required":""}},[_c('remote-select',{attrs:{"id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入项目名称/编号搜索","query-request":_vm.getBaiscProjectTable,"query-params":{customerid: _vm.projectDialog.customerId},"find-request":_vm.getProjectDetail,"clearable":""},model:{value:(_vm.projectDialog.projectid),callback:function ($$v) {_vm.$set(_vm.projectDialog, "projectid", $$v)},expression:"projectDialog.projectid"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.projectDialog.visible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.goProjectMarketTable}},[_vm._v("进入")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/group-customer-table.55f88f53039e7fe8a69a.js